<template>
  <v-dialog 
    v-model="show" 
    persistent
    max-width="500">
    <v-card>
      <v-card-title class="secondary white--text">
        確認メッセージ
      </v-card-title>
      <v-card-text class="pa-4">
        <div v-html="message"></div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="ok" color="primary">
          <v-icon left>fas fa-check</v-icon>
          OK
        </v-btn>
        <v-btn @click="cancel">
          <v-icon left>fas fa-times</v-icon>
          キャンセル
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dialog from '../mixins/dialog.js'

export default {
  name: 'Confirm',
  mixins: [dialog],
  props: {
    message: {
      type: String,
      required: true,
    },
    okAction: {
      type: Function,
      required: true,
    },
    cancelAction: {
      type: Function,
      required: true,
    },
  },
  methods: {
    ok() {
      this.okAction()
      this.close()
    },
    cancel() {
      this.cancelAction()
      this.close()
    },
  },
}
</script>

<style lang='scss' scoped>

</style>